import type { Column, CustomerQuote, TabProps } from '@talos/kyoko';

export interface ManualRFQsTabProps extends TabProps {
  defaultColumns?: (keyof CustomerQuote | Partial<Column>)[];
}

// moved to /2 in 2.54.0 when we stopped using CustomerQuotesBlotter and implemented a bespoke ManualRFQsBlotter
export const MANUAL_RFQS_PREFIX = 'manual-rfqs-blotter/2';
export const MANUAL_RFQS_PORTAL_ID = 'manual-rfqs-blotter-portal';

// Temporary type aliasing. ManualRFQ will be extended quite a bit.
export type ManualRFQ = CustomerQuote;
